import { render, staticRenderFns } from "./OrdinaryPriceTab.vue?vue&type=template&id=78afd998&"
import script from "./OrdinaryPriceTab.ts?vue&type=script&lang=js&"
export * from "./OrdinaryPriceTab.ts?vue&type=script&lang=js&"
import style0 from "./OrdinaryPriceTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports